import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

export const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    setIsVisible(scrollTop > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const button = isVisible ? (
    <button
      onClick={scrollToTop}
      className="scroll-to-top-button"
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <FontAwesomeIcon icon={faChevronUp} aria-hidden="true" />
    </button>
  ) : null;

  return typeof document !== 'undefined' 
    ? createPortal(button, document.body) 
    : null;
};

export default ScrollToTopButton;
